import { getJSON } from 'common/services/api'
import { useAbilityAccess } from 'components/AccessControl'
import { useQuery } from 'react-query'
import type { UseNoticesReturnOne } from './useNotices'

const GET_LAST_UNREAD_NOTICE = '/api/list/notices/new'

/**
 * Deliberately quiet: this feeds the unread-notice banner, and "nothing unread"
 * is an ordinary `200 { result: null }` — the banner simply doesn't render.
 * Anything worse is still the banner's problem rather than the user's, so it
 * doesn't opt into the global error toast; callers get `isError` if they want to
 * react. See `handleGlobalError` for the queries that do toast.
 */
const useLastUnreadNotice = () => {
  const canViewNotices = useAbilityAccess([{ i: 'view', this: 'Notice' }])

  const {
    isLoading,
    data: noticeData,
    isError,
    error
  } = useQuery<UseNoticesReturnOne | undefined, unknown>(
    'lastUnreadNotice',
    () => getJSON({ url: GET_LAST_UNREAD_NOTICE }),
    { enabled: canViewNotices }
  )

  return {
    isLoading,
    result: noticeData?.result,
    isError,
    error
  }
}

export default useLastUnreadNotice
